
export default function Offer() {
  return (
    <section className="offer-section py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="offer-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ lineHeight: '1.5' }}>
            1日7円の
            <br />
            「BCP(事業継続計画)」対策
          </h2>
        </div>

        <div className="bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50 rounded-3xl shadow-2xl overflow-hidden">
          <div className="p-10 md:p-14">
            <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
              {/* 画像エリア */}
              <div className="offer-image-wrap">
                <div
                  className="rounded-2xl overflow-hidden shadow-xl mx-auto offer-image-container"
                  style={{ width: '100%', maxWidth: '100%', height: '400px' }}
                >
                  <img
                    src="https://static.readdy.ai/image/929818ef5c2fcaad39934da27e65f1be/656958eab8b9a1df52e9dd3756b63396.jpeg"
                    alt="FIRE OUT 製品"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* 価格・経費エリア */}
              <div className="space-y-6">
                <div className="bg-white rounded-2xl offer-price-block shadow-lg">
                  <div className="flex flex-col items-center mb-4">
                    <span className="offer-price-label text-2xl text-gray-600 mb-2">通常価格</span>
                    <div className="flex items-baseline">
                      <span className="offer-price-value text-5xl font-bold text-red-600">¥12,800</span>
                      <span className="offer-price-tax text-xl text-gray-600 ml-2">（税込）</span>
                    </div>
                  </div>
                  <div className="text-center">
                    <p className="offer-price-period text-lg text-gray-700 mb-2">使用期限：5年間</p>
                    <p className="text-sm text-gray-600">
                      1日あたり約7円で、数千万円の資産を守ります
                    </p>
                  </div>
                </div>

                <div className="bg-green-100 rounded-2xl offer-expense-block border-2 border-green-300" style={{ padding: '1.5rem 2rem' }}>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-xl text-white"></i>
                    </div>
                    <div>
                      <p className="offer-expense-title text-lg font-bold text-gray-900 mb-2">経費計上可能</p>
                      <p className="text-sm text-gray-700">
                        本製品は「防災用品」として全額経費計上可能です。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 法人限定オファー */}
            <div className="bg-white rounded-2xl offer-corporate-block shadow-lg mb-8" style={{ padding: '2.5rem 3rem' }}>
              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-vip-crown-line text-3xl text-white"></i>
                </div>
                <h3 className="offer-corporate-title text-2xl font-bold text-gray-900 mb-3">法人限定オファー</h3>
                <p className="offer-corporate-desc text-lg text-gray-700">
                  「工場のどこに何本置くべきか？」
                  <br />
                  専門スタッフによる無料配置シミュレーション・お見積もり受付中。
                </p>
              </div>

              {/* PC表示用 */}
              <div className="offer-services-grid-pc grid md:grid-cols-3 gap-6 mt-6">
                <div className="bg-red-50 rounded-xl p-8 text-center">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-map-pin-line text-2xl text-white"></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">最適配置提案</p>
                </div>
                <div className="bg-orange-50 rounded-xl p-8 text-center">
                  <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-calculator-line text-2xl text-white"></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">詳細お見積もり</p>
                </div>
                <div className="bg-yellow-50 rounded-xl p-8 text-center">
                  <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-customer-service-line text-2xl text-white"></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">導入サポート</p>
                </div>
              </div>

              {/* スマホ表示用 */}
              <div className="offer-services-grid-mobile">
                <div className="bg-red-50 rounded-xl p-4 text-center mb-3">
                  <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-map-pin-line text-xl text-white"></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">最適配置提案</p>
                </div>
                <div className="bg-orange-50 rounded-xl p-4 text-center mb-3">
                  <div className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-calculator-line text-xl text-white"></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">詳細お見積もり</p>
                </div>
                <div className="bg-yellow-50 rounded-xl p-4 text-center">
                  <div className="w-10 h-10 bg-yellow-600 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-customer-service-line text-xl text-white"></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">導入サポート</p>
                </div>
              </div>
            </div>

            <div className="text-center">
              <a
                href="https://fireout.stores.jp/inquiry"
                target="_blank"
                rel="noopener noreferrer"
                className="offer-cta-btn inline-block bg-red-600 text-white rounded-full font-bold hover:bg-red-700 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer px-16 py-6 text-2xl"
              >
                無料お見積もり・導入のご相談
              </a>
              <p className="mt-4 text-sm text-gray-600">
                お問い合わせ後、専門スタッフより2営業日以内にご連絡いたします
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .offer-services-grid-pc { display: grid; }
        .offer-services-grid-mobile { display: none; }

        @media (max-width: 768px) {
          .offer-section {
            padding-top: 2rem !important;
            padding-bottom: 2rem !important;
          }
          .offer-heading {
            font-size: 1.5rem !important;
            line-height: 1.6 !important;
          }

          /* 画像を背景枠内に収める */
          .offer-image-wrap {
            width: 100%;
            box-sizing: border-box;
          }
          .offer-image-container {
            height: 220px !important;
          }

          /* 通常価格ブロック */
          .offer-price-block {
            padding: 1rem !important;
            width: 100%;
            box-sizing: border-box;
          }
          .offer-price-label {
            font-size: 1rem !important;
          }
          .offer-price-value {
            font-size: 2rem !important;
          }
          .offer-price-tax {
            font-size: 0.85rem !important;
          }
          .offer-price-period {
            font-size: 0.9rem !important;
          }

          /* 経費計上ブロック */
          .offer-expense-block {
            padding: 0.75rem !important;
            width: 100%;
            box-sizing: border-box;
          }
          .offer-expense-title {
            font-size: 0.95rem !important;
          }

          /* 法人限定オファーブロック */
          .offer-corporate-block {
            padding: 1rem !important;
            width: 100%;
            box-sizing: border-box;
          }
          .offer-corporate-title {
            font-size: 1.1rem !important;
          }
          .offer-corporate-desc {
            font-size: 0.85rem !important;
          }

          /* サービスグリッド切り替え */
          .offer-services-grid-pc { display: none !important; }
          .offer-services-grid-mobile {
            display: flex;
            flex-direction: column;
            width: 100%;
            box-sizing: border-box;
          }
          .offer-services-grid-mobile > div {
            width: 100%;
            box-sizing: border-box;
          }

          /* CTAボタン */
          .offer-cta-btn {
            width: 100% !important;
            padding: 0.75rem 1rem !important;
            font-size: 0.8rem !important;
            display: block !important;
            box-sizing: border-box;
          }
        }
      `}</style>
    </section>
  );
}
